export default {
  label: 'Payment method',
  addCardOptionLabel: 'Add new payment method',
  placeholder: 'Choose payment method',
};
